import React, { useEffect } from "react";

//interfaces
import { IPhoneNumberInputProps } from "./Phonenumbers.interfaces";

//hooks 
import UsePhoneNumberInput from "./PhonenumberInput.hooks";
import { getFlagEmoji, listOfCountriesToFilterOptions } from "./PhonenumberInput.utils";

//styling
import "./phonenumberinput.scss";

import CountrySelectDropdown from './CountrySelectDropdown';


const PhoneNumberInput = ({defaultData, phoneNumber, setPhoneNumberData, darkText, PhoneNumberInputStrings, localisedCountryNames}: IPhoneNumberInputProps) => {
    const {hidePhoneNumberInput, handleCountryCode, formData, setFormData} = UsePhoneNumberInput(defaultData);
    
    if (hidePhoneNumberInput) {
        return <></>;
    }

    useEffect(() => {
        setPhoneNumberData(formData);
    }, [formData.countryCode, formData.phoneNumber, formData.prefix])

    return (
        <div className={`phone-number-input-container ${!darkText && 'is-dark'}`}>
            <div className="phone-number-input-form">
                <div className="phone-number-input-div">
                    <CountrySelectDropdown
                        id={"country-select"}
                        setValue={(val: any) => handleCountryCode(val)}
                        buttonLabel={getFlagEmoji(formData.countryCode)}
                        options={listOfCountriesToFilterOptions(localisedCountryNames)}
                        defaultValue={formData.countryCode}
                        buttonAriaLabel={`select country - ${formData.countryCode} selected`}
                    />

                    <input
                        className="phone-number-input"
                        id="phone-number-input"
                        data-testid="phone-number-input"
                        aria-label={PhoneNumberInputStrings?.AriaLabel}
                        placeholder={phoneNumber || PhoneNumberInputStrings?.Placeholder}
                        type="tel"
                        onInput={(e) => {
                            const number = e.currentTarget.value.replace(/\D/g, "");
                            setFormData({...formData, phoneNumber: number,});
                        }}
                        value={formData.phoneNumber}
                    />
                </div>
            </div>
        </div>
    );
};

export default PhoneNumberInput;